import React, { useEffect } from 'react';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({
  onClose,
  onConfirm,
  confirmText,
  setConfirmText
}) => {
  const canDelete = confirmText.trim().toLowerCase() === 'delete';

  const handleConfirm = () => {
    if (canDelete) {
      onConfirm();
      setConfirmText('');
    } else {
      alert('Please type "delete" to confirm.');
    }
  };

  useEffect(() => {
    setConfirmText('');
  }, [setConfirmText]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-sm delete-confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-shell">
          <div className="modal-header">
            <div>
              <h3>Delete Profile</h3>
              <p className="modal-subtitle">
                This action is permanent. The profile and its related data cannot be restored after deletion.
              </p>
            </div>

            <button type="button" className="modal-close-btn" onClick={onClose}>
              ×
            </button>
          </div>

          <div className="modal-body">
            <div className="modal-warning-card" style={{ marginBottom: '16px' }}>
              <strong>Before you continue</strong>
              Please confirm that you want to permanently delete this record.
            </div>

            <div className="form-group">
              <label>Type "delete" to confirm</label>
              <input
                type="text"
                value={confirmText}
                onChange={(e) => setConfirmText(e.target.value)}
                placeholder="delete"
                autoFocus
              />
              <div className="modal-helper-text">
                This confirmation helps prevent accidental deletion.
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <div className="modal-footer-left" />
            <div className="modal-footer-right">
              <button className="modal-button" onClick={onClose}>
                Cancel
              </button>
              <button className="modal-button danger" onClick={handleConfirm} disabled={!canDelete}>
                Delete Profile
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;